import React from 'react';
import Typography from '@material-ui/core/Typography/Typography';
import { pieChartWithLegendBesideStyles } from '../../css/style';

const styles = pieChartWithLegendBesideStyles();

export const LegendText = ({ text, style }) => (
  <Typography style={style || styles.percentageText}>
    {text}
  </Typography>
);

export default LegendText;
